import axios from 'axios';

export default {
  initApp(context, payload) {
    context.commit('initializeApp', payload);
  },
  loadCmsData(context) {
    fetch(`${window.cmsUrl}/wp-json/wp/v2/stations?slug=${window.cmsSlug}&lang=${context.state.lang}`)
        .then(data => data.json())
        .then(data => context.commit('loadCmsDataSuccess', Array.isArray(data) ? data[0] : null))
        .catch(err => context.commit('loadCmsDataFailed', err))
  },
  switchScreen(context, payload) {
    context.commit('updateScreenState', payload)
  },
  nextStep(context) {
    context.commit('updateCurrentStep');
  },
  clickCount(context) {
    context.commit('updateClickCounter');
  },
  questionAnswered(context, payload) {
    if (payload === 'correct')
      context.commit('updateCorrectAnsweredStats');
    else
    context.commit('updateWrongAnsweredStats');
  },
  startStation(context) {
    context.commit('updateScreenState', 'quiz');
    context.commit('updateStartTimestamp', Date.now());
  },
  exitStation(context) {
    context.commit('updateEndTimestamp', Date.now());
  },
  sendStatistics(context, payload) {
    context.commit('sendStatistics');
    axios
      .post(window.apiUrl + '/api/scores', {
        station_id: payload.station_id,
        visitor_id: payload.visitor_id,
        score: payload.score,
        duration: payload.duration,
        activity: payload.activity
      })
      .then(data => context.commit('sendStatisticsSuccess', data))
      .catch(err => context.commit('sendStatisticsFailed', err))
  },
};